<template>
    <div class="container">
        <div class="form-container" v-if="loaded">
            <template>
                <vue-form
                    :structure="JSON.parse(loginForm.formData)"
                    :form-id="loginForm.id"
                    :identifier="identifier"
                    base-path=basePath
                    :csrf-token="csrfToken"
                    success-text=""
                    form-class="webform login"
                    :controller-action="loginAction"
                    :duplicate-fields="[ { source: 'email',  target: 'username' } ]"
                    :callback-success="successLogin"
                />
                <div v-if="error">
                    {{errorText}}
                </div>
                <div class="register-info">
                    <div class="inner">
                        <a :href="registerUrl">{{registerText}}</a>
                    </div>
                </div>
            </template>
        </div>
    </div>
</template>

<script>

import VueForm from 'vendor-fire/fire-core-formgenerator/src/assets/vue/frontend/Form.vue';
import { FireI18n } from 'fire-js-i18n';
import {eventBus} from 'fire-vue-core';
import gql from 'fake-tag';

export default {
    name: 'LoginElement',
    components: {
        VueForm
    },
    props: {
        identifier: {
            type: String
        },
        basePath: {
            type: String
        },
        csrfToken: {
            type: String
        },
        loginAction: {
            type: String
        },
        successText: {
            type: String
        },
        errorText: {
            type: String
        },
        registerUrl: {
            type: String
        },
        registerText: {
            type: String
        },
        redirectUrl: {
            type: String
        }
    },
    data: () => ({
        loginForm: {},
        loaded: false,
        error: false
    }),
    computed: {
    },
    methods: {
        successLogin(){
            window.location.href=this.redirectUrl;
        },
        loadForm(ident) {
            const body = {
                query: gql`
                    query getForm($ident: FormGeneratorIdentEnum!) {
                        formgenerator(ident: $ident) {
                            id
                            webFormId
                            ident
                            title
                            formData
                        }
                    }
                `,
                variables: {
                    ident
                }
            };

            fetch(graphqlApi, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': yii.getCsrfToken()
                },
                body: JSON.stringify(body)
            })
                .then(res => res.json())
                .then(res => {
                    this.loginForm = res.data.formgenerator;
                    this.loaded=true;
                });
        },
        t(key, options) {
            return FireI18n.t(key, options);
        }
    },
    mounted() {
        this.loadForm('LOGIN');

        eventBus.$on('formFail', (id) => {
            this.error = true;
        });

    }
}
</script>

<style lang="scss">
@import "frontend/styles/framework";
.register-info {
  display: flex;
  .inner {
    margin-left: auto;
    margin-right: 0;
    min-width: 208px;
    display: flex;
    a {
      font-weight: 200;
      font-size: 13px;
      margin: 0 auto;
    }
  }
}
.loginform {
  margin-left: -15px !important;
  margin-right: -15px !important;

  @media (max-width:  map-get($grid-breakpoints, md)) {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  .webform .form-item .btn {
    height: 50px;
    padding: 0;
  }
}


</style>
